export const Token = Symbol('Token');
//# sourceMappingURL=token.mjs.map